// extracted by mini-css-extract-plugin
export var badge = "_gl-2";
export var detailsPanel = "_gl-0";
export var resultRow = "_gl-1";